interface ApplePayButtonLogoProps {
  /** Defaults to the button mark's white; pass a dark value for light surfaces. */
  fill?: string;
  className?: string;
}

/**
 * The " Pay" glyph used by our Apple Pay visuals. Matches WebKit's native
 * PaymentRequest button mark so placeholder/fake buttons are indistinguishable
 * from the Apple-rendered one, and stands in for the payment-method box too —
 * the APM logo CDN serves no `logo/apple.svg`.
 */
export const ApplePayButtonLogo = ({ fill = '#ffffff', className }: ApplePayButtonLogoProps = {}): JSX.Element => (
  <svg
    width="72"
    height="28"
    viewBox="0 0 56 22"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Apple Pay"
  >
    <path
      fill={fill}
      d="M9.7 3.1c.6-.7 1-1.7.9-2.7-.8 0-1.8.5-2.4 1.2-.5.6-1 1.6-.9 2.6.9 0 1.8-.5 2.4-1.1zm.9 1.4c-1.3-.1-2.4.7-3.1.7-.6 0-1.6-.7-2.7-.7-1.4 0-2.7.8-3.4 2.1-1.5 2.5-.4 6.3 1 8.4.7 1 1.5 2.2 2.6 2.1 1-.1 1.4-.7 2.7-.7s1.6.7 2.7.7 1.8-1 2.5-2c.8-1.1 1.1-2.2 1.1-2.3-.1 0-2.2-.8-2.2-3.3 0-2.1 1.7-3.1 1.8-3.1-1-1.4-2.5-1.6-3-1.6z"
    />
    <path
      fill={fill}
      d="M21.9 2.7c2.8 0 4.7 1.9 4.7 4.7s-1.9 4.7-4.8 4.7h-3.1V17h-2.2V2.7h5.4zm-3.2 7.5h2.6c1.9 0 3-1 3-2.8 0-1.7-1.1-2.8-3-2.8h-2.6v5.6zM27.2 14c0-1.7 1.3-2.8 3.7-2.9l2.7-.2v-.8c0-1.1-.7-1.7-2-1.7-1.1 0-1.9.6-2.1 1.4h-2c.1-1.8 1.7-3.1 4.2-3.1 2.6 0 4.2 1.4 4.2 3.5V17h-2v-1.7h-.1c-.6 1.1-1.9 1.8-3.3 1.8-2 .1-3.3-1.1-3.3-3.1zm6.4-.8v-.8l-2.4.2c-1.4.1-2 .6-2 1.5s.7 1.5 1.9 1.5c1.4 0 2.5-1 2.5-2.4zM37.8 20.8v-1.7c.2 0 .5.1.7.1.9 0 1.4-.4 1.7-1.4l.2-.6L36.7 7h2.3l2.6 8.4 2.6-8.4h2.2l-3.8 10.6c-.9 2.4-1.9 3.2-4 3.2h-.8z"
    />
  </svg>
);
